import { Api } from "../axios-config/AxiosConfig";
import { ApiException } from "../ApiException";

export interface IOperacao {
    id: string;
    nome: string;
    temPermissao: boolean;
}

export interface IFuncionalidade {
    id: string;
    nome: string;
    descricao: string;
    operacoes: IOperacao[]

}
export interface IProduto {
    idProduto: string;
    nome: string;
    enderecoDoParcel: string;
    modulos: {
        id: string;
        nome: string;
        funcionalidades: IFuncionalidade[]
    }[]

}

export interface IDetalheProduto {
    idPerfil: string | number;
    produtos: IProduto[]
}

export interface IDetalhePerfis {
    Id: string | number;
    Nome: string;
};


const getPermissoes = async (Id: string | number): Promise<{ data: IProduto[] } | ApiException> => {
    try {
        const { data } = await Api.get(`/permissoes/PermissoesPorProduto?idPerfil=${Id}`);
        if (data) {
            return {
                data
            }
        }
        return new ApiException('Não foi possível mostrar os dados');
    } catch (error: any) {
        console.error(error);
        return new ApiException(error.data.data.Mensagem);
    }
}

const createPermissoes = async (dados: IDetalheProduto): Promise<IDetalheProduto | ApiException> => {
    try {
        const { data } = await Api.post('/permissoes/PermissoesPorProduto', dados);
        return data;

    } catch (error: any) {
        return new ApiException(error.data.data.Mensagem);
    }
};

const getPerfisById = async (Id: string | number): Promise<IDetalhePerfis | ApiException> => {
    try {
        const { data } = await Api.get(`/loginservice/api/v1/Perfis/${Id}`);
        if (data) {
            return data;
        } else {
            return new ApiException('Não foi possível mostrar os dados');
        }
    } catch (error: any) {
        console.error(error);
        return new ApiException(error.data.data.Mensagem);
    }
};

const createPerfis = async (dados: IDetalhePerfis): Promise<IDetalhePerfis | ApiException> => {
    try {
        const { data } = await Api.post('/loginservice/api/v1/Perfis', dados);
        if (data) {
            return data;
        }
        return new ApiException('Erro ao criar o registro');

    } catch (error: any) {
        return new ApiException(error.data.data.Mensagem);
    }
};


const updatePerfisById = async (Id: string | number, dados: IDetalhePerfis): Promise<void | ApiException> => {
    try {
        await Api.put(`/loginservice/api/v1/Perfis/${Id}`, dados);
        return;
    } catch (error: any) {
        return new ApiException(error.data.data.Mensagem);
    }
};

export const PermissoesService = {
    getPermissoes,
    createPermissoes,
    getPerfisById,
    updatePerfisById,
    createPerfis
}